<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <div class="card card-custom gutter-b">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">{{ $t('general.filter') }}</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-2 col-xl-2">
              <b-form-group label="VoterID">
                <b-form-input id="input-none" class="form-control form-control-solid" placeholder="VoterID"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.member_id')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.member_id')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.parent_id')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.parent_id')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.user_id')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.user_id')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.tc_no')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.tc_no')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.email')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.email')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.gsm_no')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.gsm_no')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.firstname')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.firstname')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.lastname')">
                <b-form-input id="input-none" class="form-control form-control-solid" :placeholder="$t('users.lastname')"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group id="input-group-4" :label="$t('users.cities')" label-for="input-3">
                <b-form-select
                    class="form-control form-control-solid"
                    v-model="form.cities"
                    :options="cities"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.start_date')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="date"
                    required
                    :placeholder="$t('users.start_date')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.end_date')" label-for="input-2">
                <b-form-input
                    class="form-control form-control-solid"
                    type="date"
                    required
                    :placeholder="$t('users.end_date')"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="col-lg-2 col-xl-2">
              <b-form-group :label="$t('users.search_by_date')">
                <b-form-checkbox-group id="checkbox-group-2" v-model="form.selected" name="flavour-2">
                  <b-form-checkbox value="orange">{{ $t('general.yes') }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <span class="fa-pull-right">
            <button type="reset" class="btn btn-outline-primary mr-10">{{ $t('general.clear') }}</button>
            <button type="submit" class="btn btn-primary">{{ $t('general.filter_') }}</button>
          </span>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box :title="$t('menu.users')">
        <template v-slot:preview>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "UserList",
  components: { DataTable, DashboardBox },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.name = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  data() {
    return {
      form : {
        cities : null,
        selected : null,
      },
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'member_id', label: 'Member ID', sortable: false},
          {key: 'ref_no', label: 'Ref No', sortable: true},
          {key: 'firstname', label: 'Ad', sortable: true},
          {key: 'lastname', label: 'Soyad', sortable: true},
          {key: 'gender', label: 'Cinsiyet', sortable: true},
          {key: 'd_date', label: 'D. Tarihi', sortable: true},
          {key: 'location', label: 'Oturduğu İl', sortable: true},
          {key: 'status', label: 'Durum', sortable: true},
          {key: 'user_action', label: 'İşlem', sortable: true},
        ],
      },
      table : {
        items : [
          {'member_id' : '3871304', 'ref_no' : '189485', 'firstname' : 'Serdar', 'lastname' : 'Mermer', 'gender' : 'Erkek', 'd_date' : '4.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871305', 'ref_no' : '309788', 'firstname' : 'Utku', 'lastname' : 'Kurtkulağı', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871306', 'ref_no' : '861329', 'firstname' : 'Burcu', 'lastname' : 'Müfit', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif','actions' : ''},
          {'member_id' : '3871307', 'ref_no' : '229893', 'firstname' : 'Hüsniye', 'lastname' : 'Tutar', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871308', 'ref_no' : '553845', 'firstname' : 'Rıza', 'lastname' : 'Bel', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871309', 'ref_no' : '971095', 'firstname' : 'Ali', 'lastname' : 'Evren', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871310', 'ref_no' : '415621', 'firstname' : 'Emre', 'lastname' : 'Duran', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871311', 'ref_no' : '531929', 'firstname' : 'Elmas', 'lastname' : 'Yıldız', 'gender' : 'Kadın', 'd_date' : '4.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871312', 'ref_no' : '137661', 'firstname' : 'Hamit', 'lastname' : 'Can', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871313', 'ref_no' : '439303', 'firstname' : 'Müge', 'lastname' : 'Ateş', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif','actions' : ''},
          {'member_id' : '3871314', 'ref_no' : '371977', 'firstname' : 'Oğuz', 'lastname' : 'Aslan', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871315', 'ref_no' : '575361', 'firstname' : 'Sinan', 'lastname' : 'Yıldırım', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871316', 'ref_no' : '786962', 'firstname' : 'Büşra', 'lastname' : 'Demir', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871317', 'ref_no' : '198541', 'firstname' : 'Yelda', 'lastname' : 'Özbakır', 'gender' : 'Kadın', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871318', 'ref_no' : '736432', 'firstname' : 'Rüzgar', 'lastname' : 'Kanca', 'gender' : 'Erkek', 'd_date' : '4.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
          {'member_id' : '3871319', 'ref_no' : '689660', 'firstname' : 'Murat', 'lastname' : 'Toptan', 'gender' : 'Erkek', 'd_date' : '3.12.1990 19:40', 'location' : 'İstanbul', 'status' : 'Aktif', 'actions' : ''},
        ],
      },
      cities: [{ text: this.$t('general.select'), value: null }, 'İstanbul', 'Ankara', 'İzmir', 'Sakarya', 'Kocaeli', 'Zonguldak', 'Kastamanonu'],
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2'), route: "alert" },
      { title: this.$t('menu.users') }
    ]);
  }
}
</script>

<style scoped>

</style>
